import { IDynamicBindableValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { TypeForItemMediaPreview, getItemMediaPreview } from '..';
import { SingleProductDataType } from '../../types/single-product-data-type';
import { onClickEventHandlers } from './on-click-event-handlers';
import { onVisibleOnceEventHandlers } from './on-visible-once-event-handlers';

const mediaProvider: IDynamicBindableValue = {
  provider: 'parent',
  property: 'itemData',
  transform: function (
    productData: SingleProductDataType,
  ): TypeForItemMediaPreview {
    return productData.media;
  }.toString(),
};

export const itemMediaPreview = {
  ...getItemMediaPreview(undefined as unknown as string, mediaProvider, {
    onClick: onClickEventHandlers,
    onVisibleOnce: onVisibleOnceEventHandlers,
  }),
};
